import { useMutation } from '@tanstack/react-query';
import { muteConversation } from '../../services/chats';

interface Options {
  onSuccess?: (muted: boolean) => void | Promise<void>;
  onError?: (mute: boolean) => void | Promise<void>;
}

function useMuteChat({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async ({
      conversationId,
      muted,
    }: {
      conversationId: string;
      muted: boolean;
    }) => {
      await muteConversation(conversationId, muted);
      return muted;
    },
    onSuccess,
    onError: (_, { muted }) => onError?.(muted),
  });
}

export default useMuteChat;
